import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col, Card, Select, Form, Input, Button, message, Switch, TimePicker, notification } from 'antd';
import { LeftOutlined, SendOutlined } from '@ant-design/icons';
import { connect } from 'dva';
import MultiImageInput from 'react-multiple-image-input';
import { antdIsValidString, convertToFormData, getUploadsImages, isEmpty } from '../../../utils/functions';
import { GoogleMap, LoadScript, Marker, Autocomplete } from '@react-google-maps/api';
import { MAP_API_KEY } from '../../../utils/constants';
import Geocode from "react-geocode";
import moment from 'moment';
import Apploader from '../../../components/loader/loader';
import ToggleDays from './ToggleDays';
import axios from 'axios';

const formItemLayout = { labelCol: { xs: { span: 24 }, sm: { span: 24 } } };
const { Option } = Select;
const { TextArea } = Input;

const StoreAddEdit = props => {
    const [form] = Form.useForm();
    const isVerify = props.location.search.substr(8);
    const idAdd = props.match.params.id === undefined;
    const { dispatch } = props;

    const [galleryImagesList, setGalleryImagesList] = useState([]);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [galleryImageUriList, setGalleryImageUriList] = useState([]);
    const [autocomplete, setAutocomplete] = useState();
    const [ispostal, sePostal] = useState(true);
    const [latLng, setLatLng] = useState({ lat: 26.896593, lng: 75.770676 });
    const [days, setDays] = useState([1, 2, 3, 4, 5, 6]);

    const cuisineList = [
        { value: 'Indian', day: 'Indian' },
        { value: 'Chinese', day: 'Chinese' },
        { value: 'Italian', day: 'Italian' },
        { value: 'American', day: 'American' },
        { value: 'German', day: 'German' }
    ];
    const storeList = [
        { value: 'Restaurants', category: 'Restaurants' },
        { value: 'Bars & Pubs', category: 'Bars & Pubs' },
        { value: 'Bakery', category: 'Bakery' },
        { value: 'Cafe', category: 'Cafe' },
        { value: 'Sweets', category: 'Sweets' }
    ];

    const locationRef = useRef();

    useEffect(() => {
        if (idAdd) {
            form.setFieldsValue({ status: true });
        } else {
            let stores = JSON.parse(sessionStorage.getItem("storesData"));

            // if (stores.open_time) stores.open_time = moment(stores.open_time, "HH:mm");
            // if (stores.close_time) stores.close_time = moment(stores.close_time, "HH:mm");
if (stores.open_time) stores.open_time = moment.utc(stores.open_time).local();
if (stores.close_time) stores.close_time = moment.utc(stores.close_time).local();
            if (stores.visiting_days) {
                const intArr = stores.visiting_days.map(day => parseInt(day));
                setDays(intArr);
            } else {
                setDays([]);
            }

            for (let i in stores) {
                form.setFieldsValue({ [i]: stores[i] });
            }

            setLatLng({ lat: stores.latitude, lng: stores.longitude });

            // ✅ Load ALL existing images
            if (stores.images?.length > 0) {
                setGalleryImageUriList(stores.images.map(img => img.url));
            }
        }
    }, [idAdd, form]);

    const onFinish = async (val) => {
        const res = await axios.get(`https://api.postalpincode.in/pincode/${val.postal}`);
        if (res.data[0].Status === "Error") {
            notification.error({ message: "This pincode is not available" });
            return;
        } else {
            sePostal(true);
        }

        if (!ispostal) {
            notification.error({ message: "This pincode is not available" });
            return;
        }

        if (!galleryImageUriList.length && galleryImagesList.length === 0) {
            return message.error('Please upload store image');
        }

        val.latitude = latLng.lat;
        val.longitude = latLng.lng;
        val.visiting_days = days;

        // if (val.open_time) val.open_time = moment(val.open_time).toISOString();
        // if (val.close_time) val.close_time = moment(val.close_time).toISOString();
        if (val.open_time) val.open_time = moment(val.open_time).utc().toISOString();
if (val.close_time) val.close_time = moment(val.close_time).utc().toISOString();

        // ✅ Build formData then append images separately
        const formData = convertToFormData(val);
    formData.append('user_id', props.match.params.user_id); // ✅ add karo
        if (galleryImagesList.length > 0) {
            galleryImagesList.forEach(image => {
                if (image && image instanceof File) {
                    formData.append('store_image', image);
                }
            });
        }

     let result;
if (props.match.params.id) {
    formData.append('_id', props.match.params.id);
    result = await dispatch({ type: 'stores/editAdmin', payload: formData }); // ✅
} else {
    result = await dispatch({ type: 'stores/addAdmin', payload: formData }); // ✅
}

        if (result.status) {
            if (isVerify === "verify") {
                props.history.push('/');
            } else {
                props.history.push('/stores');
            }
        }
    };

    const handleWeekDays = (event, value) => setDays(value);

    const cancelFun = () => {
        form.resetFields();
        if (isVerify === "verify") {
            props.history.push('/');
        } else {
            props.history.push('/stores');
        }
    };

    const onUploadGallery = async (data) => {
        let images = await getUploadsImages(data);
        setGalleryImageUriList(data);
        setGalleryImagesList([...images]);
    };

    const onLoad = useCallback((props) => setAutocomplete(props), []);

    const onPlaceChanged = () => {
        if (!isEmpty(autocomplete)) {
            const latitudeLongitude = {
                lat: autocomplete.getPlace().geometry.location.lat(),
                lng: autocomplete.getPlace().geometry.location.lng()
            };
            form.setFieldsValue({ location: autocomplete.getPlace().formatted_address });
            setLatLng(latitudeLongitude);
        }
    };

    const onMarkerDragEnd = async (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        let result = await fetchLocationName(lat, lng);
        if (result) setLatLng({ lat, lng });
    };

    const fetchLocationName = async (lat, lng) => {
        Geocode.setApiKey(MAP_API_KEY);
        Geocode.setLanguage("en");
        Geocode.setLocationType("ROOFTOP");
        Geocode.enableDebug();
        try {
            let response = await Geocode.fromLatLng(lat, lng);
            if (response) {
                const address = response.results[0].formatted_address;
                form.setFieldsValue({ address });
                return true;
            }
        } catch (e) {
            alert("Location Name not found!");
            return false;
        }
    };

    const handlePostal = async (e) => {
        let value = e.target.value;
        form.setFieldsValue({ city: '', state: '' });
        if (value.length === 6) {
            const res = await axios.get(`https://api.postalpincode.in/pincode/${value}`);
            if (res.data[0].Status === "Error") {
                sePostal(false);
            } else {
                sePostal(true);
            }
            if (res.data[0].PostOffice?.length > 0) {
                let pincode_data = res.data[0].PostOffice[0];
                form.setFieldsValue({ city: pincode_data.District, state: pincode_data.State });
            } else {
                form.setFieldsValue({ city: '', state: '' });
            }
        }
    };

    return (
        <>
            <style>{`
                /* Fix MultiImageInput 290px issue */
                .sc-AxirZ {
                    width: 100% !important;
                    max-width: 100% !important;
                    display: flex !important;
                    flex-wrap: wrap !important;
                    flex-direction: row !important;
                    gap: 10px !important;
                }
                .sc-AxhCb {
                    width: 120px !important;
                    height: 120px !important;
                    flex-shrink: 0 !important;
                    margin: 0 !important;
                }
                .sc-AxjAm {
                    width: 120px !important;
                    height: 120px !important;
                }
                .sc-AxheI {
                    width: 100% !important;
                    height: 100% !important;
                    object-fit: cover !important;
                }
                .sc-fznKkj {
                    position: absolute !important;
                    top: 4px !important;
                    right: 4px !important;
                }
                .store-section-title {
                    color: #999;
                    font-size: 11px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin: 20px 0 10px 0;
                    padding-bottom: 6px;
                    border-bottom: 1px solid #f0f0f0;
                }
                .store-form-card .ant-card-body { padding: 24px; }
                @media (max-width: 576px) {
                    .sc-AxhCb {
                        width: 90px !important;
                        height: 90px !important;
                    }
                    .sc-AxjAm {
                        width: 90px !important;
                        height: 90px !important;
                    }
                }
            `}</style>

            <Apploader show={props.loading.global} />
            <Card
                className="store-form-card"
                title={
                    <span>
                        <LeftOutlined
                            onClick={() => {
                                if (isVerify === "verify") {
                                    props.history.push('/');
                                } else {
                                    props.history.push('/stores');
                                }
                            }}
                            style={{ marginRight: 8, cursor: 'pointer' }}
                        />
                        {idAdd ? 'Add Store' : 'Edit Store'}
                    </span>
                }
                style={{ marginTop: 0 }}
            >
                <Form
                    {...formItemLayout}
                    form={form}
                    name="picture"
                    layout="vertical"
                    onFinish={onFinish}
                    className="innerFields"
                >
                    {/* ── Store Images ── */}
                    <p className="store-section-title">Store Images (Max 10)</p>
                    <Row gutter={15}>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label={<span><span style={{ color: 'red' }}>*</span> Store Images</span>}>
                                <MultiImageInput
                                    images={galleryImageUriList}
                                    setImages={onUploadGallery}
                                    allowCrop={false}
                                    theme="light"
                                    max={10}
                                    cropConfig={{ minWidth: 10, maxWidth: 2000 }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* ── Basic Info ── */}
                    <p className="store-section-title">Basic Info</p>
                    <Row gutter={15}>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item name="visiting_days" label="Visiting Days">
                                <ToggleDays days={days} handleWeekDays={handleWeekDays} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="title" label="Store Title" rules={antdIsValidString("Store Title", 40)}>
                                <Input placeholder="Store Title" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="cuisine" label="Select Store Cuisine" rules={[{ required: true, message: 'Field required!' }]}>
                                <Select mode="multiple" allowClear style={{ width: '100%' }} placeholder="Please Select Cuisine">
                                    {cuisineList.map((item, index) => (
                                        <Option key={index} value={item.day} label={item.day}>
                                            <div className="demo-option-label-item">{item.day}</div>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="store_category" label="Select Store Category" rules={[{ required: true, message: 'Field required!' }]}>
                                <Select allowClear style={{ width: '100%' }} placeholder="Please Select Category">
                                    {storeList.map((item, index) => (
                                        <Option key={index} value={item.category} label={item.category}>
                                            <div className="demo-option-label-item">{item.category}</div>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* ── Timings ── */}
                    <p className="store-section-title">Store Timings</p>
                    <Row gutter={15}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="open_time" label="Store Open Time" rules={[{ required: true, message: 'Please input your Open Time!' }]}>
                                <TimePicker
                                    showNow={false}
                                    style={{ width: '100%' }}
                                    use12Hours
                                    format="h:mm a"
                                    onChange={(time) => form.setFieldsValue({ open_time: time })}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item
                                name="close_time"
                                label="Store Close Time"
                                rules={[
                                    { required: true },
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (!value) return Promise.reject('Please input your Close Time!');
                                            const openTime = getFieldValue('open_time');
                                            if (!openTime) return Promise.resolve();
                                            const startTime = moment(openTime).format('HH:mm');
                                            const endTime = moment(value).format('HH:mm');
                                            if (startTime === '00:00' && endTime === '00:00') return Promise.resolve();
                                            if (startTime > endTime) return Promise.resolve();
                                            if (startTime < endTime) return Promise.resolve();
                                            return Promise.reject('Invalid time range');
                                        },
                                    }),
                                ]}
                            >
                                <TimePicker
                                    showNow={false}
                                    style={{ width: '100%' }}
                                    use12Hours
                                    format="h:mm a"
                                    onChange={(time) => form.setFieldsValue({ close_time: time })}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* ── Description ── */}
                    <p className="store-section-title">Description</p>
                    <Row gutter={15}>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item name="description" label="Store Description" rules={antdIsValidString("Description", 2000)}>
                                <TextArea rows={4} placeholder="Store Description" />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* ── Location ── */}
                    <p className="store-section-title">Location</p>
                    <Row gutter={15}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item
                                name="postal"
                                label="Postal"
                                onChange={(e) => handlePostal(e)}
                                rules={[{ required: true, message: 'Postal Required' }, { max: 6, message: 'Postal Code must be 6 digits' }]}
                            >
                                <Input placeholder="Postal" type="number" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="state" label="State" rules={[{ required: true, message: 'Field required!' }, { max: 20, message: 'State must not be greater than 20 characters.' }]}>
                                <Input placeholder="State" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="city" label="City" rules={[{ required: true, message: 'Field required!' }, { max: 20, message: 'City must not be greater than 20 characters.' }]}>
                                <Input placeholder="City" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <LoadScript googleMapsApiKey={MAP_API_KEY} libraries={['places']}>
                                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged} bounds={true} onUnmount={true}>
                                    <Form.Item name="address" label="Store Address" rules={[{ required: true, message: 'Field required!' }]}>
                                        <Input ref={locationRef} prefix={<SendOutlined />} placeholder="Store Address" type="text" />
                                    </Form.Item>
                                </Autocomplete>
                            </LoadScript>
                        </Col>
                    </Row>

                    {/* ── Map ── */}
                    <Row gutter={15} style={{ height: 400, width: '100%', marginBottom: 24 }}>
                        <Col xs={24} sm={24} md={24}>
                            <LoadScript googleMapsApiKey={MAP_API_KEY} libraries={['places']}>
                                <GoogleMap
                                    center={latLng}
                                    zoom={15}
                                    mapContainerStyle={{ width: '100%', height: '100%', borderRadius: 8 }}
                                >
                                    <Marker position={latLng} draggable={true} onDragEnd={(e) => onMarkerDragEnd(e)} />
                                </GoogleMap>
                            </LoadScript>
                        </Col>
                    </Row>

                    {/* ── Settings ── */}
                    <p className="store-section-title">Settings</p>
                    <Row gutter={15}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="status" valuePropName='checked' label="Store Status">
                                <Switch checkedChildren="Publish" unCheckedChildren="UnPublish" />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* ── Buttons ── */}
                    <Form.Item className="mb-0">
                        <Button onClick={cancelFun} size="large">Cancel</Button>&nbsp;&nbsp;
                        <Button type="primary" disabled={btnDisabled} size="large" onClick={() => form.submit()}>Save</Button>
                    </Form.Item>

                </Form>
            </Card>
        </>
    );
};

export default connect(({ stores, loading }) => ({
    stores, loading
}))(StoreAddEdit);